<div class="calendar-container">
  <!-- Header Section - Matching Change Order Style -->
  <div class="calendar-header-section">
    <div class="calendar-controls">
      <!-- Search Section -->
      <div class="search-section">
        <mat-icon>search</mat-icon>
        <input type="text" [(ngModel)]="search" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onSearch()"
          (keyup.enter)="onSearch()" placeholder="Search events..." class="search-input">
        <mat-icon *ngIf="search" (click)="clearSearch()" class="clear-search-icon">
          close
        </mat-icon>
      </div>

      <!-- Create Button -->
      <button *ngIf="!hideCreateButton" class="btn-add-event" (click)="openEventDialog(null, null, null)"
        [matTooltip]="!isEventCreate() ? 'You are not authorized to create events' : 'Create new event'"
        [disabled]="isLocked || !isEventCreate()" [ngClass]="{'permission-disabled': isLocked || !isEventCreate()}">
        <mat-icon>add</mat-icon>
        <span>Create</span>
      </button>

      <!-- View Toggle -->
      <div class="view-toggle">
        <button class="toggle-btn" [class.activeBtn]="viewMode === 'calendar'" (click)="setViewMode('calendar')"
          matTooltip="Calendar View">
          <mat-icon>calendar_month</mat-icon>
        </button>
        <button class="toggle-btn" [class.activeBtn]="viewMode === 'list'" (click)="setViewMode('list')"
          matTooltip="List View">
          <mat-icon>view_list</mat-icon>
        </button>
      </div>

      <!-- Settings Button -->
      <button *ngIf="!hideSettingsButton" [matMenuTriggerFor]="settingsMenu" class="settings-button" matTooltip="Settings"
        [disabled]="isLocked || !isEventEdit()"
        [ngClass]="{'permission-disabled': isLocked || !isEventEdit()}">
        <mat-icon>settings</mat-icon>
      </button>

      <!-- Settings menu -->
      <mat-menu #settingsMenu="matMenu" class="settings-menu">
        <div class="settings-menu-content">
          <div class="settings-menu-header">Event Background Color</div>
          <mat-radio-group class="settings-radio-group bidone-radio" [value]="calendarBgSource"
            (change)="onBidCalendarBgChange($event.value)">
            <mat-radio-button class="settings-radio" value="default">Main Category
            </mat-radio-button>
            <mat-radio-button class="settings-radio" value="status" [disabled]="isLocked || !isEventEdit()"
              [ngClass]="{'permission-disabled': isLocked || !isEventEdit()}">Status</mat-radio-button>
          </mat-radio-group>
        </div>
      </mat-menu>
    </div>
  </div>

  <!-- Calendar View -->
  <div class="calendar-view" *ngIf="viewMode === 'calendar'">
    <ejs-schedule #schedule [eventSettings]="eventSettings" [currentView]="currentView" [views]="views"
      [showHeaderBar]="true" (cellClick)="onCellClick($event)" (cellDoubleClick)="onCellDoubleClick($event)"
      (eventRendered)="onEventRendered($event)" (popupOpen)="onPopupOpen($event)" (dragStart)="onDragStart($event)"
      (dragStop)="onDragStop($event)" (resizeStart)="onResizeStart($event)" (resizeStop)="onResizeStop($event)"
      (actionComplete)="onScheduleActionComplete($event)" height="750px">
      <e-views>
        <e-view option="Day">
          <ng-template #eventTemplate let-data="">
            <div class="custom-content-days">
              <div class="event-left-section">
                <div class="event-status-indicator"></div>
                <div class="event-content">
                  <div class="event-time">
                    {{ data.StartTime | date : "HH:mm" }}
                  </div>
                  <div class="event-title">{{ data.Subject }}</div>
                </div>
              </div>
              <div class="event-right-section">
                <!-- Bucket overflow badge — only on warehouse delivery
                     calendar and only when this event "absorbed"
                     siblings via the hour-bucket grouping. -->
                <button
                  type="button"
                  class="event-bucket-more"
                  *ngIf="data._bucketSiblings?.length"
                  (click)="onBucketOverflowClick($event, data)"
                  [title]="'+' + data._bucketSiblings.length + ' more in this hour'"
                >+{{ data._bucketSiblings.length }}</button>
                <div class="event-category-bars" *ngIf="hasNonMainCategories(data.calendar_categories)">
                  <div class="category-bar cursor-pointer" *ngFor="
                      let category of getFilteredCategories(
                        data.calendar_categories
                      )
                    " [style.background-color]="category.color" [matTooltip]="category.title"
                    matTooltipPosition="above"></div>
                </div>
              </div>
            </div>
          </ng-template>
        </e-view>
        <e-view option="Week">
          <ng-template #eventTemplate let-data="">
            <div class="custom-content-week">
              <div class="event-left-section-week">
                <div class="event-status-indicator-week"></div>
                <div class="event-content-week">
                  <div class="event-time-week">
                    {{ data.StartTime | date : "HH:mm" }}
                  </div>
                  <div class="event-title-week">{{ data.Subject }}</div>
                </div>
              </div>
              <div class="event-right-section-week">
                <!-- Bucket overflow badge — see Day template comment. -->
                <button
                  type="button"
                  class="event-bucket-more"
                  *ngIf="data._bucketSiblings?.length"
                  (click)="onBucketOverflowClick($event, data)"
                  [title]="'+' + data._bucketSiblings.length + ' more in this hour'"
                >+{{ data._bucketSiblings.length }}</button>
                <div class="event-category-bars-week" *ngIf="hasNonMainCategories(data.calendar_categories)">
                  <div class="category-bar-week cursor-pointer" *ngFor="
                      let category of getFilteredCategories(
                        data.calendar_categories
                      )
                    " [style.background-color]="category.color" [matTooltip]="category.title"
                    matTooltipPosition="above"></div>
                </div>
              </div>
            </div>
          </ng-template>
        </e-view>
        <e-view option="Week" interval="2" displayName="Two Weeks">
          <ng-template #eventTemplate let-data="">
            <div class="custom-content-week">
              <div class="event-left-section-week">
                <div class="event-status-indicator-week"></div>
                <div class="event-content-week">
                  <div class="event-time-week">
                    {{ data.StartTime | date : "HH:mm" }}
                  </div>
                  <div class="event-title-week">{{ data.Subject }}</div>
                </div>
              </div>
              <div class="event-right-section-week">
                <!-- Bucket overflow badge — see Day template comment. -->
                <button
                  type="button"
                  class="event-bucket-more"
                  *ngIf="data._bucketSiblings?.length"
                  (click)="onBucketOverflowClick($event, data)"
                  [title]="'+' + data._bucketSiblings.length + ' more in this hour'"
                >+{{ data._bucketSiblings.length }}</button>
                <div class="event-category-bars-week" *ngIf="hasNonMainCategories(data.calendar_categories)">
                  <div class="category-bar-week cursor-pointer" *ngFor="
                      let category of getFilteredCategories(
                        data.calendar_categories
                      )
                    " [style.background-color]="category.color" [matTooltip]="category.title"
                    matTooltipPosition="above"></div>
                </div>
              </div>
            </div>
          </ng-template>
        </e-view>
        <e-view option="Month" [rowAutoHeight]="true">
          <ng-template #eventTemplate let-data="">
            <div class="custom-content-month">
              <div class="event-left-section-month">
                <div class="event-status-indicator-month"></div>
                <div class="event-content-month">
                  <!-- <div class="event-time-month">{{data.StartTime | date:'HH:mm'}}</div> -->
                  <div class="event-title-month">{{ data.Subject }}</div>
                </div>
              </div>
              <div class="event-right-section-month">
                <div class="event-category-bars-month" *ngIf="hasNonMainCategories(data.calendar_categories)">
                  <div class="category-bar-month cursor-pointer" *ngFor="
                      let category of getFilteredCategories(
                        data.calendar_categories
                      )
                    " [style.background-color]="category.color" [matTooltip]="category.title"
                    matTooltipPosition="above"></div>
                </div>
              </div>
            </div>
          </ng-template>
        </e-view>
        <e-view option="Agenda">
          <ng-template #eventTemplate let-data="">
            <div class="custom-content-agenda">
              <div class="event-left-section-agenda">
                <div class="event-status-indicator-agenda"></div>
                <div class="event-content-agenda">
                  <div class="event-time-agenda">
                    {{ data.StartTime | date : "HH:mm" }}
                  </div>
                  <div class="event-title-agenda">{{ data.Subject }}</div>
                  <div class="event-date-agenda">
                    {{ data.StartTime | date : "MMM dd, yyyy" }}
                  </div>
                </div>
              </div>
              <div class="event-right-section-agenda">
                <div class="event-category-bars-agenda" *ngIf="hasNonMainCategories(data.calendar_categories)">
                  <div class="category-bar-agenda cursor-pointer" *ngFor="
                      let category of getFilteredCategories(
                        data.calendar_categories
                      )
                    " [style.background-color]="category.color" [matTooltip]="category.title"
                    matTooltipPosition="above"></div>
                </div>
              </div>
            </div>
          </ng-template>
        </e-view>
        <!-- <e-view option="TimelineMonth" [group]="timelineGroup"></e-view> -->
        <e-view option="Year">
          <ng-template #eventTemplate let-data="">
            <div class="custom-content-year">
              <div class="event-left-section-year">
                <div class="event-status-indicator-year"></div>
                <div class="event-content-year">
                  <div class="event-time-year">
                    {{ data.StartTime | date : "HH:mm" }}
                  </div>
                  <div class="event-title-year">{{ data.Subject }}</div>
                </div>
              </div>
              <div class="event-right-section-year">
                <div class="event-category-bars-year" *ngIf="hasNonMainCategories(data.calendar_categories)">
                  <div class="category-bar-year cursor-pointer" *ngFor="
                      let category of getFilteredCategories(
                        data.calendar_categories
                      )
                    " [style.background-color]="category.color" [matTooltip]="category.title"
                    matTooltipPosition="above"></div>
                </div>
              </div>
            </div>
          </ng-template>
        </e-view>
      </e-views>
    </ejs-schedule>
  </div>

  <!-- List View -->
  <div class="event-list-view" *ngIf="viewMode === 'list'">
    <!-- Loading State -->
    <div class="loading-state" *ngIf="isLoadingEvents">
      <mat-spinner diameter="48"></mat-spinner>
      <p>Loading events...</p>
    </div>

    <!-- Error State -->
    <div class="empty-state-enhanced" *ngIf="!isLoadingEvents && hasError">
      <mat-icon>error_outline</mat-icon>
      <h3>Error Loading Events</h3>
      <p>Failed to load events. Please try again.</p>
    </div>

    <!-- Events Table -->
    <table class="event-table-enhanced"
      *ngIf="!isLoadingEvents && !hasError && eventListData && eventListData.length > 0">
      <thead>
        <tr>
          <th>Event Title</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Status</th>
          <th class="actions-header">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let event of eventListData; trackBy: trackByEventId" class="event-row"
          [style.border-left]="'4px solid ' + (event.status?.color || '#ff6600')">
          <td class="event-title-cell">
            <div class="event-title-wrapper">
              <mat-icon class="event-icon">event</mat-icon>
              <strong>{{ event.title }}</strong>
              <span class="event-type-badge" *ngIf="event.is_all_day === 1">All Day</span>
            </div>
          </td>
          <td>
            <div class="date-cell">
              <span class="date-text">{{ formatDateForDisplay(event.start_date) }}</span>
              <span class="time-text" *ngIf="event.is_all_day !== 1 && event.start_date_time">
                {{ formatTimeForDisplay(event.start_date_time) }}
              </span>
            </div>
          </td>
          <td>
            <div class="date-cell">
              <span class="date-text">{{ formatDateForDisplay(event.end_date) }}</span>
              <span class="time-text" *ngIf="event.is_all_day !== 1 && event.end_date_time">
                {{ formatTimeForDisplay(event.end_date_time) }}
              </span>
            </div>
          </td>
          <td>
            <span class="status-badge" [style.background-color]="(event.status?.color || '#ff6600') + '20'"
              [style.color]="event.status?.color || '#ff6600'">
              {{ event.status?.name || 'Active' }}
            </span>
          </td>
          <td class="actions-cell" (click)="$event.stopPropagation()">
            <button class="btn-icon-small" [matMenuTriggerFor]="eventMenu" matTooltip="More Actions" type="button">
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #eventMenu="matMenu" class="event-actions-menu">
              <button mat-menu-item (click)="editEventFromList(event, $event)"
                [disabled]="!isEventEdit() || event.can_edit === 0"
                [ngClass]="{'permission-disabled': !isEventEdit() || event.can_edit === 0}" class="event-menu-item-edit">
                <!-- <mat-icon>edit</mat-icon> -->
                <span>Edit Event</span>
              </button>
              <button mat-menu-item (click)="deleteEventFromList(event, $event)"
                [disabled]="!isEventDelete()"
                [ngClass]="{'permission-disabled': !isEventDelete()}"
                class="event-menu-item-delete delete-menu-item">
                <!-- <mat-icon>delete</mat-icon> -->
                <span>Delete Event</span>
              </button>
            </mat-menu>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Empty State for List View -->
    <div class="empty-state-enhanced"
      *ngIf="!isLoadingEvents && !hasError && (!eventListData || eventListData.length === 0)">
      <mat-icon>event_busy</mat-icon>
      <h3>No Events Found</h3>
      <p>{{ search ? 'Try adjusting your search terms' : 'No events have been created yet' }}</p>
      <button class="btn-primary" *ngIf="!search" (click)="openEventDialog(null, null, null)"
        [disabled]="isLocked || !isEventCreate()" [ngClass]="{'permission-disabled': isLocked || !isEventCreate()}">
        <mat-icon>add</mat-icon>
        <span>Create First Event</span>
      </button>
    </div>
  </div>
</div>